// extracted by mini-css-extract-plugin
export var backdropBlur = "_cc-0";
export var contentCard = "_cc-5";
export var frame = "_cc-2";
export var image = "_cc-4";
export var imagePane = "_cc-3";
export var modal = "_cc-1";